export const APP_NAME = 'Direct Affinity CX'
export const COPYRIGHT_APP_NAME = ''
export const LOGIN_LOGO_JUSTIFY = 'justify-center'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'